import { render, staticRenderFns } from "./CollectionArea.vue?vue&type=template&id=20379fc4&scoped=true&"
import script from "./CollectionArea.vue?vue&type=script&lang=js&"
export * from "./CollectionArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20379fc4",
  null
  
)

export default component.exports